import { render, staticRenderFns } from "./InventoryPageAttributesWithType.vue?vue&type=template&id=8c1d1718"
import script from "./InventoryPageAttributesWithType.vue?vue&type=script&lang=js"
export * from "./InventoryPageAttributesWithType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports